// API Configuration Utility
// This file provides consistent API base URL handling for both axios and fetch calls

/**
 * Get the API base URL based on the current environment
 * @returns {string} The API base URL
 */
// export const getApiBaseUrl = () => {
//   return process.env.REACT_APP_API_URL ||
//     (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
//       ? 'http://localhost:3000'
//       : `${window.location.protocol}//${window.location.hostname}`);
// };

export const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_URL ||
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://localhost:3000'  // ← Always localhost for local testing
      : window.location.hostname.includes('develop')
          ? 'https://develop-api.kbhclassroom.com'
          : `${window.location.protocol}//${window.location.hostname}`);
};

/**
 * Create a full API URL by combining base URL with endpoint
 * @param {string} endpoint - The API endpoint (e.g., '/api/news/articles')
 * @returns {string} The full API URL
 */
export const createApiUrl = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  // Ensure endpoint starts with / and baseUrl doesn't end with /
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  // Add /api prefix for all endpoints
  const apiEndpoint = cleanEndpoint.startsWith('/api') ? cleanEndpoint : `/api${cleanEndpoint}`;
  return `${cleanBaseUrl}${apiEndpoint}`;
};

